import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleNew16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#21A67A"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 8L7 11L12.5 5.5",
		stroke: "white",
		strokeWidth: 2
	})]
});
export default SvgCheckCircleNew16;
